import { render, staticRenderFns } from "./courseTabTitle.vue?vue&type=template&id=4a6561ec&scoped=true&"
import script from "./courseTabTitle.vue?vue&type=script&lang=js&"
export * from "./courseTabTitle.vue?vue&type=script&lang=js&"
import style0 from "./courseTabTitle.vue?vue&type=style&index=0&id=4a6561ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6561ec",
  null
  
)

export default component.exports